import { AppDetails, FileStatus } from './utils';
// Definition taken from here:
// https://github.com/OpenVnmrJ/OpenVnmrJ/blob/master/src/vnmr/data.h
/**
 * File Header - First 32 bytes. The file header is the first block of the file.
 * @param buffer the fid file as iobuffer
 * @return Metadata
 */
export class FileHeader {
    constructor(buffer) {
        buffer.offset = 0; /** offset must be zero for analyzing FH */
        this.nBlocks = buffer.readInt32();
        this.nTraces = buffer.readInt32();
        this.np = buffer.readInt32();
        this.eBytes = buffer.readInt32();
        this.tBytes = buffer.readInt32();
        this.bBytes = buffer.readInt32();
        this.version = new AppDetails(buffer.readInt16());
        this.status = new FileStatus(buffer.readInt16());
        this.nBlockHeaders = buffer.readInt32();
    }
}
//# sourceMappingURL=readFileHeader.js.map